import { useQuery } from '@apollo/client';
import { GetPolicyPermissionDecision } from './GetPolicyDecision.graphql';
import { GetDecisionModel } from '@utmost.co/enterprise-models';

export const useGetPolicyDecision = (permissionAction: string, permissionName: string, resourceUid: string) => {
  const { data, loading, error } = useQuery<{ getPolicyDecision: GetDecisionModel }>(GetPolicyPermissionDecision, {
    variables: { permissionAction, permissionName, resourceUid }
  });

  return {
    loading,
    error: error || null,
    data: data?.getPolicyDecision || null
  };
};
